// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
// Import Swiper styles
import './SwiperList.scss';
import { observer } from 'mobx-react-lite';
import { store } from '../stores/Store';
import { SmallCard } from './SmallCard';
import { useRef } from 'react';

const SwiperList = observer(({ id = 'SwiperList', items = [], activeIndex = 0, renderItem, ...rest }) => {
    const node = useRef(null);

    var props = {
        modules: [Navigation, Pagination],
        spaceBetween: 10,
        slidesPerView: 4,
        threshold: 10,
        navigation: {
            nextEl: `#${id} .swiper-button-next`,
            prevEl: `#${id} .swiper-button-prev`,
            enabled: true
        },
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 4,
                spaceBetween: 10,
            },
            // when window width is >= 480px
            480: {
                slidesPerView: 5,
                spaceBetween: 10,
            },
            // when window width is >= 640px
            900: {
                slidesPerView: 4,
                spaceBetween: 10,
                // navigation: true,
            }
        },
        ...rest
    }
    return (
        <div id={id} className="SwiperList" ref={node}>
            {/* {items.map((item, i) => {
                return <SmallCard
                    title={item.title}
                    image={item.image}
                    checked={store.selectedMaterialId === item.id}
                    onClick={e => {
                        store.selectMaterial(item.id)
                    }} />
            })} */}

            <Swiper
                {...props}
                onSlideChange={() => console.log('slide change')}
                onSwiper={(swiper) => {
                    swiper.slideTo(activeIndex)
                    // console.log(swiper);
                }}
            >
                {
                    items.map((item, i) => {
                        return <SwiperSlide key={i}>{
                            renderItem(item, i)
                        }</SwiperSlide>
                    })
                }
            </Swiper>
            <div className="swiper-button-next"></div>
            <div className="swiper-button-prev"></div>
        </div>
    );

})
SwiperList.displayName = 'SwiperList'



export {
    SwiperList
}